export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      4033.015873015873,
    ],
    button_spin: [
      6000,
      547.1201814058961,
    ],
    end_free_spin: [
      8000,
      2770.430839002268,
    ],
    free_bet_big_win: [
      12000,
      1377.2335600907031,
    ],
    free_bet_mega_win: [
      15000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      19000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      21000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      24000,
      29255.69160997732,
    ],
    free_spin_popup: [
      55000,
      2770.430839002266,
    ],
    free_spin_start: [
      59000,
      4358.0952380952385,
    ],
    inside_buttons: [
      65000,
      245.26077097505095,
    ],
    main_ambient: [
      67000,
      61876.825396825385,
    ],
    mega_win: [
      130000,
      3974.965986394551,
    ],
    outside_buttons: [
      135000,
      352.6530612244869,
    ],
    reel_spin: [
      137000,
      2538.231292516997,
    ],
    reel_stop_01: [
      141000,
      216.23582766440563,
    ],
    reel_stop_02: [
      143000,
      201.72335600906877,
    ],
    reel_stop_03: [
      145000,
      201.72335600906877,
    ],
    reel_stop_04: [
      147000,
      251.0657596371857,
    ],
    reel_stop_05: [
      149000,
      181.40589569159715,
    ],
    regular_win: [
      151000,
      570.3401360544262,
    ],
    scatter_chance: [
      153000,
      2277.0068027210755,
    ],
    tap_to_play: [
      157000,
      4268.117913832213,
    ],
    ultra_win: [
      163000,
      3734.058956916101,
    ],
  },
}
